<template>
     <lx-dialog
      :is-visible-dialog.sync="isVisiable"
      :width="'75vw'"
      is-custome-footer
      class="lx-select-goods"
      @close="handleClose"
    >
      <div slot="title" class="title-dialog">
          <el-row>
              <el-col :span="12">
                  {{$t('select.select1')}}
              </el-col>
              <el-col :span="12">
                    {{$t('select.select2')}}{{ curSelectList.length }}个
              </el-col>
          </el-row>
      </div>
        <div class="main">
            <el-row :gutter="30">
                <el-col :span="12">
                    <div class="lx-flex-row" style="margin-bottom:20px;">
                        <el-input v-model="searchForm.goodsName" :placeholder="$t('select.select3')"></el-input>
                        <el-input style="margin:0 20px;" class="ml15" v-model="searchForm.orderId" :placeholder="$t('select.select4')"></el-input>
                        <el-button class="lx-flex-shrink-0 ml15" type="primary" @click.native="doSearch">{{$t('select.select5')}}</el-button>
                        <el-button class="lx-flex-shrink-0 ml15" type="primary" @click.native="doReset">{{$t('select.select6')}}</el-button>
                    </div>
                </el-col>
            </el-row>
            <el-row :gutter="30">
                <el-col :span="12">
                    <el-table   ref="multipleTable" row-key="id" class="mt20 mb10" @selection-change="handleSelectionChange" :data="dataList" border>
                       <el-table-column
      type="selection"
      align="center"
      reserve-selection
      width="55">
    </el-table-column>
                        <el-table-column prop="orderId" :label="$t('select.select7')" header-align="center" align="center" width="80">
                        </el-table-column>
                        <el-table-column :label="$t('select.select8')" header-align="center" align="center">
                          <template slot-scope="scope">
                            {{scope.row.goodsName | empty}}
                          </template>
                        </el-table-column>
                        <el-table-column prop="createTime" :label="$t('select.select9')" header-align="center" align="center" >
                            <template v-slot="scope">
              {{ scope.row.createTime | dateFormatToDay }}
            </template>
                        </el-table-column>
                        <el-table-column prop="receiveTime" :label="$t('select.select10')" header-align="center" align="center" >
                            <template v-slot="scope">
              {{ scope.row.receiveTime | dateFormatToDay }}
            </template>
                        </el-table-column>
                        <el-table-column :label="$t('select.select11')" header-align="center" align="center" width="120">
                            <template slot-scope="scope">
                                <el-tag  type="success" size="mini" effect="dark">
                                    {{scope.row.orderStatus | orderStatusFilter}}
                                </el-tag>
                            </template>
                        </el-table-column>
                    </el-table>
                    <el-pagination
                        :current-page="searchForm.pageNum"
                        :page-sizes="[5, 10, 20, 50, 100]"
                        :page-size="searchForm.pageSize"
                        :total="total"
                        layout="total, sizes, prev, pager, next, jumper"
                        @size-change="pageSizeChangeHandle"
                        @current-change="pageCurrentChangeHandle">
                    </el-pagination>
                </el-col>
                <el-col :span="12">
                     <el-table class="mt20 mb10" :data="curSelectList" max-height="600px" :empty-text="$t('select.select12')" border>
                        <el-table-column header-align="center" width="50" align="center">
                            <template slot-scope="scope">
                                <i class="el-icon-circle-close fz16 lx-pointer" @click.stop="handleCurrentChange(scope.row)"></i>
                            </template>
                        </el-table-column>
                        <el-table-column prop="orderId" :label="$t('select.select7')" header-align="center" align="center" width="150">
                        </el-table-column>
                        <el-table-column :label="$t('select.select8')" header-align="center" align="center">
                          <template slot-scope="scope">
                            {{scope.row.goodsName | empty}}
                          </template>
                        </el-table-column>
                        <el-table-column prop="createTime" :label="$t('select.select9')" header-align="center" align="center" width="80">
                          <template v-slot="scope">
              {{ scope.row.createTime | dateFormatToDay }}
            </template>
                        </el-table-column>
                        <el-table-column prop="receiveTime" :label="$t('select.select10')" header-align="center" align="center" width="100">
                          <template v-slot="scope">
              {{ scope.row.receiveTime | dateFormatToDay }}
            </template>
                        </el-table-column>
                         <el-table-column :label="$t('select.select11')" header-align="center" align="center" width="120">
                            <template slot-scope="scope">
                                <el-tag  type="success" size="mini" effect="dark">
                                    {{scope.row.orderStatus | orderStatusFilter}}
                                </el-tag>
                            </template>
                        </el-table-column>
                    </el-table>
                </el-col>
            </el-row>
        </div>
        <el-dialog
  :visible.sync="dialogVisible"
  width="600px"
  :modal='false'
  :before-close="closAlready"
  :modalAppendToBody='false'
  >
  <span>{{$t('select.select13')}}</span>
   <el-table
    ref="singleTable"
    :data="splitList"
    highlight-current-row
    @current-change="handleCurrentChangeOnly"
    style="width: 100%">
    <el-table-column
      property="tongkunNo"
      :label="$t('select.select14')"
      width="120">
    </el-table-column>
    <el-table-column
      property="createTime"
      :label="$t('select.select15')"
      width="120">
        <template v-slot="scope">
              {{ scope.row.createTime | dateFormatToDay }}
            </template>
    </el-table-column>
    <el-table-column
      property="receiverName"
      :label="$t('select.select16')">
    </el-table-column>
     <el-table-column
      property="status"
      :label="$t('select.select17')">
        <template v-slot="scope">
              {{ tongkunStatusShow(scope.row.status) }}
            </template>
    </el-table-column>
  </el-table>
  <span slot="footer" class="dialog-footer">
    <el-button @click="closAlready">{{$t('cancel')}}</el-button>
    <el-button type="primary" @click="handleSaveNew">{{$t('confirm')}}</el-button>
  </span>
</el-dialog>
      <div slot="custome-footer" class="lx-flex-row-center">
        <el-button
          @click.native="handleClose"
          >{{$t('cancel')}}</el-button
        >
         <el-button
          type="primary"
          class="mr30"
          @click.native="handleAlready"
          >{{$t('select.select18')}}</el-button
        >
         <el-button
          type="primary"
          class="mr30"
          @click.native="handleNew"
          >{{$t('select.select19')}}</el-button
        >
      </div>
    </lx-dialog>
</template>
<script>
import LxDialog from '@/components/LxDialog'
import { filterValues } from '@/assets/js/utils.js'


export default {
  name: 'LxSelectGoods',
  components: { LxDialog },
  props: {
    title: {
      type: String,
      default: ''
    },
    selectList: {
      type: Array,
      default: () => []
    },
    visible: {
      type: Boolean,
      default: false
    },
    id:{
      type: Number,
      default: -1
    }
  },
  data () {
    return {
      dataList: [],
      curSelectList: [],
      total: 0,
      searchForm:{
          pageNum: 1,
          goodsName:'',
          orderId:'',
          pageSize: 10,
      },
      timeout: null,
      dialogVisible:false,
        currentRow: null,
        splitList:[]
    }
  },
   computed: {
    isVisiable: {
      get () {
        return this.visible
      },
      set (val) {
        this.$emit('update:visible', val)
      }
    }
  },
  watch: {
    isVisiable (val) {
      if (val) {
        this.getDataList()
      }else{
        this.curSelectList = []
        this.$refs.multipleTable.clearSelection();
      }
    },
  },
  methods: {
    doSearch () {
      this.searchForm.page = 1
      this.getDataList(this.curSelectList)
    },
    closAlready(){
      this.currentRow = null
      this.dialogVisible = false
    },
    handleSaveNew(){
      if(this.currentRow){
          let params = {
          tongkunOrderList:this.curSelectList,
          id:this.id,
          targetTongkunId:this.currentRow.id
        }
        this.$http.post('/tongkun/splitTongkun', params).then(res => {
          if(res.data.code==200){
             this.$message.success(this.$t('select.select20'))
             this.isVisiable = false
             this.currentRow = null
              this.$emit('confirm')
              this.dialogVisible = false
          }else{
               this.$message.error(res.data.message)
          }
      })
      }else{
        this.$message.error(this.$t('select.select21'))
      }
    },
    //拆分到已有同捆
    handleAlready(){
      if(this.curSelectList.length==0){
        this.$message.error(this.$t('select.select22'))
      }else{
        this.dialogVisible = true
      this.getSplitList()
      }
    },
    handleNew(){
      if(this.curSelectList.length==0){
        this.$message.error(this.$t('select.select22'))
      }else{
        let params = {
          tongkunOrderList:this.curSelectList,
          id:this.id
        }
        this.$http.post('/tongkun/splitTongkun', params).then(res => {
          if(res.data.code==200){
             this.$message.success(this.$t('select.select20'))
             this.isVisiable = false
             this.currentRow = null
             this.$emit('confirm')
          }else{
               this.$message.error(res.data.message)
          }
      })
      }
    },
     tongkunStatusShow(status) {
      switch (status) {
        case '1':
          return this.$t('BuddleOrder.BuddleOrder2')
        case '2':
          return this.$t('orderList.orderList33')
        case '3':
          return this.$t('BuddleOrder.BuddleOrder1')
        case '4':
          return this.$t('orderList.orderList108')
        case '5':
          return this.$t('orderList.orderList8')
        case '6':
          return this.$t('orderList.orderList11')
        case '7':
          return this.$t('orderList.orderList73')
        case '9':
          return this.$t('status.status4')
      }
    },
    hasAddressCheck(status){
      switch (status) {
        case '1':
          return this.$t('BuddleOrder.BuddleOrder2')
        case '2':
          return this.$t('orderList.orderList33')
        case '3':
          return this.$t('BuddleOrder.BuddleOrder1')
        case '4':
          return this.$t('orderList.orderList108')
        case '5':
          return this.$t('orderList.orderList8')
        case '6':
          return this.$t('orderList.orderList11')
        case '7':
          return this.$t('orderList.orderList73')
        case '9':
          return this.$t('status.status4')
      }
    },
     setCurrent(row) {
        this.$refs.singleTable.setCurrentRow(row);
      },
      handleCurrentChangeOnly(val) {
        this.currentRow = val;
      },
    // 选择
    handleSelectionChange (list) {
      this.curSelectList = list
    },
    // 删除某一项
   handleCurrentChange(row) {
        this.dataList.forEach(item=>{
          if(item.id==row.id){
             this.$refs.multipleTable.toggleRowSelection(item,false);
          }
        })
      },
    getDataList () {
      this.searchForm.id = this.id
      const params = this.searchForm
      this.$http.get('/tongkun/pageForOrderList', { params }).then(res => {
        let data = res.data.data
        this.total = data.total
        this.dataList = data.list
      })
    },
     
    getSplitList () {
      const params = {
        id:this.id
      }
      this.$http.get('/tongkun/getSplitOrderList', { params }).then(res => {
        this.splitList = res.data.data
      })
    },
    // 初始化列表样式
    initList () {
    
    },
    // 取消
    handleClose () {
      this.isVisiable = false
    },
    // 确定
    handleSave () {
      this.$emit('confirm', this.curSelectList)
    },
    // 重置
    doReset () {
      console.log(this.searchForm)
      this.searchForm.orderId = ''
      this.searchForm.goodsName = ''
      this.searchForm.pageNum = 1
    },

    // 分页, 每页条数
    pageSizeChangeHandle (val) {
      this.searchForm.pageNum = 1
      this.searchForm.pageSize = val
      this.$nextTick(() => {
        this.getDataList()
      })
    },
    // 分页, 当前页
    pageCurrentChangeHandle (val) {
      this.searchForm.pageNum = val
      this.$nextTick(() => {
        this.getDataList()
      })
    }
  }
}
</script>
<style lang="scss" scoped>
::v-deep .el-table .el-table__body tr.el-table__row.current-row td, .el-table__body tr.current-row>td, .el-table__body tr.hover-row.current-row>td, .el-table__body tr.hover-row.el-table__row.current-row>td, .el-table__body tr.hover-row.el-table__row>td, .el-table__body tr.hover-row>td

{

background-color:#c1d3e7;

}

</style>
